import {createApp,  VueElement} from 'vue';
import App from './App.vue';
import '../node_modules/bootstrap/dist/css/bootstrap.css'

createApp(App).mount('#app');